import { Button, styled } from '@mui/material';

export const PrimaryButton = styled(Button)({
  backgroundColor: "#C3F0F7",
  color: "#202641",
  border: "2px solid #C3F0F7",
  borderRadius: 30,
  height: 50,
  fontWeight: 500,
  fontSize:16,
  lineHeight: 1.4,
  padding: '0 25px',
  "&:hover": {
    backgroundColor: "transparent",
    color: "#FFF"
  },
  "&:active": {
    backgroundColor: "transparent",
    color: "#FFF"
  },
  "&:disabled": {
    pointerEvents: "auto",
    cursor: "not-allowed",
    color: "#202641",
    "&:hover": {
      backgroundColor: "#C3F0F7",
      color: "#202641"
    }
  }
})

export const PrimaryButton2th = styled(Button)({
  backgroundColor: "#C3F0F7",
  color: "#202641",
  border: "2px solid #C3F0F7",
  borderRadius: 30,
  height: 50,
  fontSize:16,
  lineHeight: 1.4,
  fontWeight: 500,
  padding: '0 25px',
  "&:hover": {
    border: "2px solid #0E2F6C",
    backgroundColor: "transparent",
    color: "#0E2F6C"
  },
  "&:active": {
    border: "2px solid #0E2F6C",
    backgroundColor: "transparent",
    color: "#0E2F6C"
  }
})

export const SecondaryButton = styled(Button)({
  backgroundColor: "transparent",
  color: "#FFF",
  border: "2px solid #C3F0F7",
  borderRadius: 30,
  height: 50,
  fontWeight: 500,
  fontSize:16,
  padding: '0 25px',
  "&:hover": {
    backgroundColor: "#C3F0F7",
    color: "#202641"
  },
  "&:active": {
    backgroundColor: "#C3F0F7",
    color: "#202641"
  }
})

export const SecondaryButton2th = styled(Button)({
  backgroundColor: "transparent",
  color: "#C3F0F7",
  border: "2px solid #C3F0F7",
  borderRadius: 30,
  height: 50,
  fontWeight: 500,
  fontSize:16,
  padding: '0 25px',
  "&:hover": {
    backgroundColor: "#C3F0F7",
    color: "#202641"
  },
  "&:active": {
    backgroundColor: "#C3F0F7",
    color: "#202641"
  }
})

export const ThirdButton = styled(Button)({
  backgroundColor: "transparent",
  color: "#202641",
  border: "2px solid #202641",
  borderRadius: 30,
  height: 50,
  fontWeight: 500,
  fontSize:16,
  padding: '0 25px',
  "&:hover": {
    backgroundColor: "#202641",
    color: "#202641"
  },
  "&:active": {
    backgroundColor: "#202641",
    color: "#202641"
  }
})



